import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import OrdersPageHeading from 'components/OrdersPageHeading';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
import PackWidget from 'components/PackWidget';
import TabBar from 'components/TabBar';
import { ReactComponent as NoResultSvg } from 'images/no-results.svg';
import { addDataLayer } from 'lib/GoogleTagManager';

const DisplayPack = styled.div`
  display: ${({ handleDisplayPack }) => (handleDisplayPack ? 'block' : 'none')};

  > ${FullWidthPageContent} {
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
  }

  .noResultsPanel {
    background: ${({ theme }) => theme.palette.background.paper};
    display: flex;
    padding: 100px 0;
    flex-direction: column;
    justify-content: center;

    > * {
      margin-left: auto;
      margin-right: auto;
      margin-top: 0;
    }

    svg {
      width: 120px;
      height: 120px;
    }
  }
`;

const TabBarWrapper = styled(FullWidthPageContent)`
  margin-bottom: 0;
`;

const OrdersPageView = ({ upcomingPacks, previousPacks }) => {
  const [selectedTab, setSelectedTab] = useState('Upcoming');
  const tabs = [
    { label: 'Upcoming' },
    { label: 'Completed' },
  ];

  const handleTabClick = ({ label }) => {
    if (label !== selectedTab) {
      setSelectedTab(label);
      addDataLayer({ action: 'Orders & Payments Click', label });
    }
  };

  return (
    <>
      <OrdersPageHeading />
      <TabBarWrapper>
        <TabBar tabs={tabs} onTabClick={handleTabClick} />
      </TabBarWrapper>
      <DisplayPack className="upcoming" handleDisplayPack={selectedTab === 'Upcoming'}>
        {upcomingPacks.map((pack, index) => (
          <FullWidthPageContent key={pack.id}>
            <PackWidget pack={pack} showPayments={index === 0} hideBottomSection />
          </FullWidthPageContent>
        ))}
        {!upcomingPacks.length && (
          <FullWidthPageContent className="noResultsPanel">
            <NoResultSvg />
            <h2>There&apos;s nothing to see here.</h2>
            <p>You have no upcoming orders.</p>
          </FullWidthPageContent>
        )}
      </DisplayPack>

      <DisplayPack className="completed" handleDisplayPack={selectedTab === 'Completed'}>
        {previousPacks.map((pack, index) => (
          <FullWidthPageContent key={pack.id}>
            <PackWidget pack={pack} showPayments={index === 0} hideBottomSection />
          </FullWidthPageContent>
        ))}
        {!previousPacks.length && (
          <FullWidthPageContent className="noResultsPanel">
            <NoResultSvg />
            <h2>There&apos;s nothing to see here.</h2>
            <p>You have no completed orders yet.</p>
          </FullWidthPageContent>
        )}
      </DisplayPack>
    </>
  );
};

OrdersPageView.displayName = 'OrdersPageView';

OrdersPageView.propTypes = {
  previousPacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  upcomingPacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default OrdersPageView;
